import React from 'react';
import { useLocation } from 'react-router-dom';

import PageHeader from '../../Components/PageHeader/PageHeader';

const ProjectsDetails = () => {
    const location = useLocation()
    const { state } = location

    return (
        <>
            <PageHeader
                title="Project"
                breadcrumbs={[
                    { label: 'Home', href: '/' },
                    { label: 'Projects', href: '/projects' },
                    { label: state?.name }
                ]}
            />

            <div className="container pb-5 pt-5" >
                <h2 className="mb-5">{state?.name}</h2>

                <img
                    src={`https://api.coeupdspadelhi.in/uploads/${state?.image}`}
                    className="card-img-top"
                    alt={state?.name}
                />

                {/* {
                    state?.img_creit &&
                    <Link to={state?.img_creit} target='_blank'>
                        <p className='text-primary text-end'>Image Credit Goes To</p>
                    </Link>
                } */}

                <p className="mt-5">
                    {state?.description}
                </p>

                <h5 className="mt-5">
                    Timeline: {state?.time_line}
                </h5>
                <h5>
                    Status: {state?.status}
                </h5>
                <h4 className='mt-4 mb-2 text-bold'>
                    Team Member:
                </h4>
                {state?.team_members &&
                    <h5>
                        {JSON.parse(state?.team_members)?.map((item, key) => (
                            <p key={key}>{item}</p>
                        ))}
                    </h5>
                }




            </div>

        </>
    );
};

export default ProjectsDetails;